import { Component } from '@angular/core';

import { faChevronLeft, faSignOutAlt } from '@fortawesome/pro-solid-svg-icons';

import { AuthService } from 'src/api-authorization/auth.service';

/**
 * Public layout for pages displayed to unauthorised users.
 *
 * @export
 * @class PublicLayoutComponent
 */
@Component({
    selector: 'app-public',
    templateUrl: './public.layout.html',
    standalone: false
})
export class PublicLayoutComponent {
  /**
   * Back icon.
   *
   * @memberof PublicLayoutComponent
   */
  faChevronLeft = faChevronLeft;

  /**
   * Sign out icon
   *
   * @memberof PublicLayoutComponent
   */
  faSignOutAlt = faSignOutAlt;

  /**
   * Whether the user is signed in or not.
   *
   * @memberof PublicLayoutComponent
   */
  isSignedIn = false;

  /**
   * Constructor.
   * @param authorize The authorization service.
   */
  constructor(private authService: AuthService) {
    this.isSignedIn = this.authService.isAuthenticated();
  }
}
